import { bind } from 'bind-decorator';
import { ItemResponse } from 'labxchange-client';
import messages from 'library/displayMessages';
import { detailUrlForEntity } from 'library/utils';
import * as React from 'react';
import Slider from 'react-slick';
import { WrappedMessage } from 'utils';
import { Card } from '../Card';

interface Props {
    similarItems: ItemResponse[];
    moreItemsBySource: ItemResponse[];
}

interface State {
    selectedSimilarItemsTab: boolean;
}

export class RecommendedContentWidget extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            selectedSimilarItemsTab: true,
        };
    }

    public render() {
        return (
            <aside className='recommended-content-widget container-fluid'>
                <div className='content-widget-tabs d-flex justify-content-start'>
                    {this.props.similarItems !== undefined && this.props.similarItems.length > 0
                    ?   <button onClick={this.selectSimilarItemsTab}
                            className={this.state.selectedSimilarItemsTab ? 'selected' : undefined}>
                            <WrappedMessage message={messages.similarItemsTab} />
                        </button>
                    : null}
                    {this.props.moreItemsBySource !== undefined && this.props.moreItemsBySource.length > 2
                    ?   <button onClick={this.selectMoreItemsBySourceTab}
                            className={!this.state.selectedSimilarItemsTab ? 'selected' : undefined}>
                            <WrappedMessage message={messages.moreItemsBySourceTab} />
                        </button>
                    : null}
                </div>
                {this.renderContent()}
            </aside>
        );
    }

    @bind private selectSimilarItemsTab(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        this.setState({selectedSimilarItemsTab: true});
    }

    @bind private selectMoreItemsBySourceTab(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        this.setState({selectedSimilarItemsTab: false});
    }

    private renderContent() {
        const similarItems: JSX.Element[] = [];
        if (this.props.similarItems !== undefined && this.props.similarItems.length > 0) {
            this.props.similarItems.map((itemResponse, index) => (
                similarItems.push(
                    <Card
                        key={'similar-items-' + index}
                        metadata={itemResponse.metadata}
                        mobileViewMode={true}
                        detailUrl={detailUrlForEntity(itemResponse.metadata)}
                        userAttributes={itemResponse.userAttributes}
                    />,
                )
            ));
        }
        const otherItemsBySource: JSX.Element[] = [];
        if (this.props.moreItemsBySource !== undefined && this.props.moreItemsBySource.length > 0) {
            this.props.moreItemsBySource.map((itemResponse, index) => (
                otherItemsBySource.push(
                    <Card
                        key={'more-by-source-' + index}
                        metadata={itemResponse.metadata}
                        mobileViewMode={true}
                        detailUrl={detailUrlForEntity(itemResponse.metadata)}
                        userAttributes={itemResponse.userAttributes}
                    />,
                )
            ));
        }
        const settings = {
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            speed: 0,
            responsive: [
                {
                    breakpoint: 970,
                    settings: {
                        centerMode: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false,
                    },
                },
                {
                    breakpoint: 530,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        swipeToSlide: true,
                        variableWidth: true,
                    },
                },
            ],
        };
        switch (this.state.selectedSimilarItemsTab) {
            case true:
                return (
                    <Slider {...settings}>
                        {similarItems}
                    </Slider>
                );
            case false:
                return (
                    <Slider {...settings}>
                        {otherItemsBySource}
                    </Slider>
                );
            default: return null;
        }
    }
}
